import { useContext } from 'react';
import type { FC } from 'react';
import classnames from 'classnames';
import { useNavigate } from 'react-router-dom';
import type { LocaldataProps } from 'react-localdata';
import { LocaldataContext } from 'react-localdata';

import Button from 'app/components/Button';
import Icon from 'app/components/Icon';
import arrowIcon from 'app/icons/arrow_long.svg';

import style from './style.scss';

interface Props {
  children: string;
  to?: string;
  className?: string;
}

const BackButton: FC<Props> = ({ children, to, className }) => {
  const navigate = useNavigate();
  const { localdata }: LocaldataProps<AppLocaldata> = useContext(LocaldataContext);
  const collapsed = localdata.menuCollapsed;

  const handleClick = () => (to ? navigate(to) : navigate(-1));
  const buttonClassName = classnames(style.backButton, className, {
    [style.backButton_collapsed]: collapsed
  });

  return (
    <Button variation="empty" onClick={handleClick} className={buttonClassName}>
      <Icon href={arrowIcon} className={style.backButtonIcon} />
      {!collapsed && children}
    </Button>
  );
};

BackButton.displayName = 'BackButton';

export default BackButton;
